import * as Dialog from '@radix-ui/react-dialog';
import React, { useState } from 'react';

import { BaseButton } from '../../../components/button/BaseButton';
import { IMinimalCargoType } from './CargoTypeComboboxField';
import { CreateCargoTypeForm } from './CreateCargoTypeForm';

export interface ICreateCargoTypeDialogProps {
  triggerText: React.ReactElement;
  onSubmit: (data: IMinimalCargoType) => void | Promise<void>;
}

export const CreateCargoTypeDialog: React.FC<ICreateCargoTypeDialogProps> = (props) => {
  const { triggerText, onSubmit } = props;
  const [open, setOpen] = useState(false);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <BaseButton>{triggerText}</BaseButton>
      </Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Overlay className="dialog-overlay" />
        <Dialog.Content className="dialog-content">
          <Dialog.Title className="heading-one mb-4">Maak inhoudstype aan</Dialog.Title>

          <div>
            <CreateCargoTypeForm
              onCancel={() => setOpen(false)}
              onComplete={(data) => {
                onSubmit(data);
                setOpen(false);
              }}
            />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
